import {
  Dashboard, ManageTeam, RegisterTeam, MyTeam, TeamPage,
  PlayerPage, ManagePlayer, Administration
} from '../screens'

export const routes = [
  { path: '/', exact: true, component: Dashboard },
  { path: '/team/:id', component: TeamPage },
  { path: '/player/:id', component: PlayerPage },
  { path: '/profile', component: ManagePlayer },
  { path: '/myteam', exact: true, component: MyTeam },
  { path: '/myteam/register', component: RegisterTeam },
  { path: '/myteam/manage', component: ManageTeam },
  { path: '/administration', component: Administration }
]



// WEBPACK FOOTER //
// ./src/config/routes.js